import { Link } from "react-router-dom";

const Banner = ({ image, link }) => {
  return (
    <Link
      to={link || "#"}
      target="_blank"
      rel="noopener noreferrer"
      className="w-[500px] h-[250px] max-sm:h-[180px] shadow-2xl shadow-black flex justify-center items-center bg-white rounded-lg max-lg:w-full overflow-hidden"
    >
      {image ? (
        <img
          src={image}
          alt="banner"
          className="w-full h-full object-cover rounded-lg"
        />
      ) : (
        <span className="text-gray-500">Բաներ</span>
      )}
    </Link>
  );
};

export default Banner;
